import EsamiLaboratorioEdit from "./components/EsamiLaboratorioEdit.vue";
import EsamiLaboratorioView from "./components/EsamiLaboratorioView.vue";
import EsamiLaboratorioList from "./components/EsamiLaboratorioList.vue";

export default {
    EsamiLaboratorioEdit,
    EsamiLaboratorioView,
    EsamiLaboratorioList,
};
